 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML01_HALF from '@/components/xhtml/01_Half'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML02_TITLE from '@/components/xhtml/02_Title'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML05_ILLUSTRATIONS from '@/components/xhtml/05_Illustrations'
 import XHTML06_ACKNOWLEDGMENTS from '@/components/xhtml/06_Acknowledgments'
 import XHTML07_INTRODUCTION from '@/components/xhtml/07_Introduction'
 import XHTML08_ORIGIN from '@/components/xhtml/08_Origin'
 import XHTML09_USE_THIS_BOOK from '@/components/xhtml/09_Use_This_Book'
 import XHTML10_THE_ARTWORK from '@/components/xhtml/10_The_Artwork'
 import XHTML11_CHAPTER01 from '@/components/xhtml/11_Chapter01'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML12_APPENDIX_I from '@/components/xhtml/12_Appendix_I'
 import XHTML13_APPENDIX_II from '@/components/xhtml/13_Appendix_II'
 import XHTML14_READING from '@/components/xhtml/14_Reading'
 import XHTML15_NOTES from '@/components/xhtml/15_Notes'
 import XHTML16_THE_AUTHOR from '@/components/xhtml/16_The_Author'
 import XHTML17_THE_ARTIST from '@/components/xhtml/17_The_Artist'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/01_Half",
 			"name" : "xhtml/01_Half",
 			"component" : XHTML01_HALF
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/02_Title",
 			"name" : "xhtml/02_Title",
 			"component" : XHTML02_TITLE
 		},
 		{
 			"path" : "/xhtml/03_Copyright",
 			"name" : "xhtml/03_Copyright",
 			"component" : XHTML03_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/04_Dedication",
 			"name" : "xhtml/04_Dedication",
 			"component" : XHTML04_DEDICATION
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/05_Illustrations",
 			"name" : "xhtml/05_Illustrations",
 			"component" : XHTML05_ILLUSTRATIONS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js